const prefix = "splitpay_reward_half_card__";

export const SPLIT_PAY_REWARDS_HALF_CARD_TEST_IDS = {
    CONTAINER: `${prefix}container`,
};
